import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/external-finishings.php';

export function getExternalFinishings() {

    const response = api.get(service_path);

    return response;
};

export function getExternalFinishingDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createExternalFinishing(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Acabamento cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateExternalFinishing(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Acabamento editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteExternalFinishing(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Acabamento externo deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse acabamento externo!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};